export default __webpack_public_path__ + "static/media/single-timezone-img.aaeec546.png";